<div class="dialog">
  <div class="dialog-background" (click)="onClose()"></div>
  <div class="dialog-content">
    <div class="dialog-close">
      <app-ds-icon name="close-x" size="icon-size-3" color="var(--color-core-neutral-7)" (click)="onClose()"></app-ds-icon>
    </div>

    <div class="referrals-dialog">
      <h1 class="ds-title-3 ds-color-core-neutral-10">{{ 'ACCOUNT.promotion.invite.modal.title' | translate }}</h1>
      <p class="ds-heading-2 ds-color-core-neutral-8">{{ 'ACCOUNT.promotion.invite.modal.subtitle' | translate }}</p>

      <div class="ds-card">
        <p [innerHTML]="inviteText" class="ds-running-2 ds-color-core-neutral-9"></p>
      </div>

      <div class="referrals-share-box">
        @for (sharePlatform of sharePlatforms; track sharePlatform) {
          @if (sharePlatform === 'email') {
            <button (click)="onReferralShare('email')" class="ui-button-round social">
              <span class="icon-i-email"></span>
            </button>
          } @else {
            <button
              (click)="onReferralShare(sharePlatform)"
              class="ui-button-round social"
              [ngClass]="{ 'xs-hide': sharePlatform === 'facebook' }"
              [description]="getMessage(sharePlatform, vm)"
              [url]="'https://app.inyova.ch/invite/' + vm.referralCode"
              [shareButton]="sharePlatform"
            >
              <span [class]="'icon-i-' + sharePlatform"></span>
            </button>
          }
        }
      </div>

      <div class="referrals-share-close">
        <app-ds-button type="button" variant="outline" size="default" width="auto" (click)="onClose()">{{
          'ACCOUNT.promotion.invite.modal.btn' | translate
        }}</app-ds-button>
      </div>
    </div>
  </div>
</div>
